/**
 * RUM view custom-timing names.
 */
export const PROMO_DETAILS_TIMINGS = {
    /** Promo data has arrived. */
    DATA_READY: 'rewards_promo_details_data_ready',
    /** Promo content painted */
    CONTENT_RENDERED: 'rewards_promo_details_content_rendered',
    /** Embedded GameZone tiles painted. */
    GAMEZONE_RENDERED: 'rewards_promo_details_gamezone_rendered'
} as const;

/**
 * App-owned Rewards Hub (`/rewards`) RUM view custom-timings.
 *
 * The per-fetch (`rewards_hub_*_data_ready`) and per-component
 * (`rewards_hub_*_rendered`) timings are emitted by `@fanduel/rewards-hub-client`
 * (`RUM_TIMINGS`). This adds the composite "hub usable" signal casino-next owns.
 */
export const REWARDS_HUB_TIMINGS = {
    /**
     * Composite "hub usable" signal — emitted once per view when BOTH blocking
     * fetches complete (`/components` and `/retrieveStructured`). The hub only
     * becomes usable at the *later* of the two, so this is the headline
     * load-time signal; the two `*_data_ready` timings stay as per-fetch
     * sub-signals for attribution (which half was slow).
     */
    READY: 'rewards_hub_ready'
} as const;
